'use client';

import React from 'react';

export const LazyCalculator = React.lazy(() =>
  import(
    /* webpackChunkName: 'InstallmentCalculator' */ '../InstallmentCalculator/InstallmentCalculator.client'
  ).then((module) => ({ default: module.InstallmentCalculator })),
);
